<ng-container *ngIf="hospid">

    <div class="container-fluid">
      <div class="row justify-content-start">
        <div class="col-sm-5">
          <h4 class="title">
            <p>User Management</p>
          </h4>
          <div class="form-group">
            <label>Form Fields go here</label>
  
  
          </div>
        </div>
      </div>
    </div>
  </ng-container>